/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { storyblokEditable } from '@storyblok/react/rsc'
import React from 'react'

import { Image } from '@/components/ui/Image'
import { ImageStoryblok } from '@/lib/storyblok/types/generated-types'
import { getAssetImageDimensions } from '@/lib/storyblok/utils/image-asset'
import { cn } from '@/utils/css'

/** A description of the available properties for this component. */
type ImageProps = {
  /** The Storyblok blok that represents this component. */
  blok: ImageStoryblok
}

/**
 * A Storyblok component for displaying an image.
 */
const StoryblokImage: React.FC<ImageProps> = ({ blok }) => {
  const { src, shadow, rounded, fill, maximum_height } = blok

  // Extract the dimensions of the image asset
  const originalDimensions = getAssetImageDimensions(src)

  // Restrict the dimensions of the image if a maximum height is provided
  const dimensions = maximum_height
    ? {
        height: Number(maximum_height),
        width: Math.round((originalDimensions.width / originalDimensions.height) * Number(maximum_height)),
      }
    : originalDimensions

  return (
    <Image
      {...storyblokEditable(blok)}
      src={src.filename}
      alt={src.alt ?? ''}
      shadow={shadow}
      rounded={rounded}
      fill={fill}
      className={cn(fill && 'object-cover')}
      {...(!fill ? dimensions : {})}
    />
  )
}

export { StoryblokImage }
